import { Directive, HostBinding, Input } from '@angular/core';

import { normalizeToken } from '../utils/a11y.util';

const A11Y_TABLE_HEADER_SCOPES = ['col', 'row'] as const;

@Directive({
  selector: 'th[khA11yTableHeader]'
})
export class A11yTableHeaderDirective {
  @Input('khA11yTableHeader') public scope: 'col' | 'row' = 'col';

  @HostBinding('attr.scope')
  public get headerScope(): 'col' | 'row' {
    return normalizeToken(this.scope, A11Y_TABLE_HEADER_SCOPES, 'col') ?? 'col';
  }
}
